import Vue from 'vue'
import RbFooter from '@/elements/footer/rb-footer.vue'
Vue.component('rb-footer', RbFooter)

import RbLazyPaymentIcon from '@/elements/lazy/lazy-payment-icon/rb-lazy-payment-icon.vue'
Vue.component('rb-lazy-payment-icon', RbLazyPaymentIcon)

import RbCountryOverlay from '@/elements/footer/country-overlay.lazy.vue'
Vue.component('rb-country-overlay', RbCountryOverlay)

import RbCountrySelector from '@/elements/footer/country-selector.lazy.vue'
Vue.component('rb-country-selector', RbCountrySelector)

import RbCountrySelectorMobile from '@/elements/footer/country-selector-mobile.lazy.vue'
Vue.component('rb-country-selector-mobile', RbCountrySelectorMobile)

import RbRadioAccordion from '@/elements/radio-accordion/rb-radio-accordion.vue'
Vue.component('rb-radio-accordion', RbRadioAccordion)

import RbFooterMail from '@/scripts/components/rb-newsletter-forms.vue'
Vue.component('rb-footer-mail', RbFooterMail)

import RbFooterOtherSitesLink from '@/elements/footer/footer-other-sites-link.vue'
Vue.component('rb-footer-other-sites-link', RbFooterOtherSitesLink)
import RbFooterOtherSitesLinkContainer from '@/elements/footer/footer-other-sites-link-container.vue'
Vue.component('rb-footer-other-sites-link-container', RbFooterOtherSitesLinkContainer)

const RbFooterContactForm = () =>
  import(/* webpackChunkName: "footer-chunk" */ '@/elements/footer/footer-contact-form.vue')
Vue.component('rb-footer-contact-form', RbFooterContactForm)

const RbBtnFooter = () =>
  import(/* webpackChunkName: "footer-chunk" */ '@/elements/footer/btn-footer.vue')
Vue.component('rb-btn-footer', RbBtnFooter)

const RbMentionMe = () =>
  import(/* webpackChunkName: "mention-me-chunk" */ '@/elements/mention-me/mention-me.lazy.vue')
Vue.component('rb-mention-me', RbMentionMe)

import RbFooterMentionMeLink from '@/elements/footer/footer-mention-me-link.vue'
Vue.component('rb-footer-mention-me-link', RbFooterMentionMeLink)

import RbTrustPilotFooter from '@/elements/trust-pilot/rb-trust-pilot-footer.vue'
Vue.component('rb-trust-pilot-footer', RbTrustPilotFooter)

const RbSeoRelatedLinks = () =>
  import(/* webpackChunkName: "footer-chunk" */ '@/elements/seo/rb-seo-related-links.vue')
Vue.component('rb-seo-related-links', RbSeoRelatedLinks)

const RbSeoDescription = () =>
  import(/* webpackChunkName: "footer-chunk" */ '@/elements/seo/rb-seo-description.vue')
Vue.component('rb-seo-long-description', RbSeoDescription)

const RbDoctorLocator = () => import('@/elements/doctor-locator/rb-doctor-locator.vue')
Vue.component('rb-doctor-locator', RbDoctorLocator)

const RbRoxPanel = () =>
  import(/* webpackChunkName: "prescription-chunk" */ '@/elements/rox-panel/rb-rox-panel.vue')
Vue.component('rb-rox-panel', RbRoxPanel)
